import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import parseNumerical from '@/common/helpers/parse-numerical';

export default class AddNsfFeeActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({
            amount: this.amount = null,
            productId: this.productId = null,
        } = fields);
        this.amount = parseNumerical(this.amount);
    }

    getPayload() {
        return {
            ...super.getPayload(),
            amount: Number(this.amount),
            productId: this.productId,
        };
    }
}
